<template>
  <header v-if="!isMobile">
    <div class="logo-wrapper">
      <div class="logo">
        <img
          v-if="newYearIconShow"
          src="../../assets/newYearLogo.png"
          alt=""
          srcset=""
        />
        <img v-else src="../../assets/header-logo.png" />
      </div>
      <router-link to="/" class="home-link">
        SmartEnglish
        <div class="new-year-icon" v-if="newYearIconShow">
          <!-- <img src="../../assets/new-year.png" alt="" srcset="" /> -->
          <img class="tree" src="../../assets/tree.gif" alt="" srcset="" />
        </div>
      </router-link>
    </div>
    <div class="garland" v-if="newYearIconShow">
      <garland />
      <div class="snowflakes">
        <SnowFlakes />
      </div>
    </div>
    <!-- <vs-breadcrumb>
      <nav v-if="$breadcrumbs.length" aria-label="breadcrumb">
        {{ $breadcrumbs }}
      </nav>
    </vs-breadcrumb> -->
    <Notices />
    <schoolyear-select />
    <GlobalSearch />
  </header>
  <header v-else>
    <vs-dropdown class="header-menu" vs-custom-content vs-trigger-click>
      <vs-icon icon="menu"></vs-icon>

      <vs-dropdown-menu class="header-mobile-menu" v-if="user && token">
        <router-link :to="{ name: 'Teacher', params: { teacher_id: user.id } }">
          <vs-avatar
            :src="
              user.options
                ? `${proxy}/static/files/${user.options.avatar}`
                : null
            "
          >
          </vs-avatar>
          {{ user.name }}
        </router-link>
        <GlobalSearch />
        <router-link to="/teachers" v-if="$can('manage', 'teacher')">
          <vs-icon icon="school"></vs-icon>Teachers
        </router-link>
        <router-link to="/groups">
          <vs-icon icon="group"></vs-icon>Groups
        </router-link>
        <router-link to="/students">
          <vs-icon icon="person"></vs-icon>Students
        </router-link>
        <router-link to="/books" v-if="$can('manage', 'books')">
          <vs-icon icon="import_contacts"></vs-icon> Books
        </router-link>
        <router-link to="/timetable">
          <vs-icon icon="event_available"></vs-icon>Timetable
        </router-link>
        <router-link to="/orders" v-if="$can('manage', 'orders')">
          <vs-icon icon="insert_chart_outlined"></vs-icon>Orders
        </router-link>
        <router-link to="/payments" v-if="$can('manage', 'payments')">
          <vs-icon icon="attach_money"></vs-icon>Payments
        </router-link>
        <router-link to="/tasks" v-if="$can('manage', 'all_tasks_view')">
          <vs-icon icon="task_alt"></vs-icon>Tasks
        </router-link>
        <router-link to="/calendar" v-if="$can('manage', 'calendar')">
          <vs-icon icon="calendar_month"></vs-icon>Calendar
        </router-link>
        <router-link to="/settings" v-if="$can('manage', 'settings')">
          <vs-icon icon="settings"></vs-icon>Settings
        </router-link>
      </vs-dropdown-menu>
    </vs-dropdown>
    <div class="logo-wrapper">
      <div class="logo">
        <img
          v-if="newYearIconShow"
          src="../../assets/newYearLogo.png"
          alt=""
          srcset=""
        />
        <img v-else src="../../assets/header-logo.png" />
      </div>
      <router-link to="/" class="home-link">
        SmartEnglish
        <div class="new-year-icon" v-if="newYearIconShow">
          <!-- <img src="../../assets/new-year.png" alt="" srcset="" /> -->
          <img class="tree" src="../../assets/tree.gif" alt="" srcset="" />
        </div>
      </router-link>
    </div>
    <Notices />
    <schoolyear-select />
  </header>
</template>

<script>
import { mapState } from 'vuex'
import GlobalSearch from '@/components/common/search'
import SchoolyearSelect from './schoolyearSelect.vue'
import SnowFlakes from './snowflakes.vue'
import garland from './garland.vue'
import Notices from './elements/notices.vue'

export default {
  components: {
    GlobalSearch,
    SchoolyearSelect,
    SnowFlakes,
    Notices,
    garland,
  },
  data() {
    return {
      newYearIconShow: false,
      user: localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : {},
      proxy: process.env.VUE_APP_PROXY,
      token: localStorage.getItem('token'),
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.app.isMobile,
    }),
  },
  created() {},
}
</script>

<style lang="scss">
.content > header {
  width: 100%;
  height: 45px;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
  padding: 5px 25px;
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 401;
  justify-content: space-between;
  .logo-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    .logo {
      width: 2rem;
      height: 2rem;
      margin-right: 7px;
      // margin-top: -4px;
      img {
        height: 100%;
      }
    }
    a {
      display: block;
    }
    .home-link {
      position: relative;
      .new-year-icon {
        position: absolute;
        right: -3.6rem;
        top: -1.2rem;
        width: 40px;
        height: 50px;
        img {
          height: 100%;
        }
        z-index: -1;
      }
    }
  }
  .schoolyear-select {
    .selected {
      background-color: #eee;
    }
  }
}
.snowflakes {
  position: absolute;
  height: 50px;
  overflow: hidden;
  width: 400px;
  z-index: -1;
  left: -3px;
  top: 0;
}
.garland {
  position: absolute;
  top: 0;
  left: 5px;
  opacity: 0.4;
  z-index: -2;
  width: 100%;
  height: 50px;
}
.header-mobile-menu {
  width: 50%;
  display: flex;
  flex-flow: column nowrap;
  gap: 2rem;
}
.header-mobile-menu .vs-dropdown--menu a {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 1rem;
  color: #2c3e50cc;
  padding: 5px;
}
</style>
